<p-dialog *ngIf="task" [closable]="false" [responsive]="true" [(visible)]="currentDisplay" [modal]="!isMini"
    [style]="{width: '70vw'}" [ngClass]="{ 'miniDialogtask': isMini, 'topDialogtask' : !isMini }">
    <ng-template pTemplate="header">
        <div class="p-d-flex w-100 p-jc-between">
            <h5 class="p-mb-0" style="flex-grow: 1;" *ngIf="!isMini">View Task Details</h5>
            <div>
                <span class="btnBars" (click)="refreshViewData()" 
                pTooltip="Refresh Details" tooltipPosition="top"
                [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"
                  >
                    <i class="pi pi-refresh"></i>
                </span>
                <span class="btnBars" (click)="isMini = true;onBodyAuto();" *ngIf="!isMini" 
                pTooltip="Minimize" tooltipPosition="top"
                [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"
                  >
                    <i class="pi pi-window-minimize"></i>
                </span>

                <span *ngIf="isMini && [TaskType.Individual,TaskType.Subtask].includes(task?.taskTypeId) && (app?.userId==taskData?.createdBy || app?.userId==taskData?.assignedTo || app?.userId==taskData?.reAssignedTo)" class="p-mr-3 p-ml-2">
                    <span>{{getTimeTracked(task) | date :"HH:mm:ss":'UTC'}}</span>
                    <span class="cursor-pointer pi pi-clock p-ml-2" (click)="startTaskTimer(task)" *ngIf="!task?.taskStartTime && !task.isCompleted"
                        pTooltip="Start Timer" tooltipPosition="bottom"
                        [tooltipOptions]="{
                            showDelay: 50,
                            hideDelay: 50,
                            positionStyle: 'fixed',
                            appendTo: 'body'
                          }"
                          ></span>
                    <span class="cursor-pointer fa fa-stop-circle-o p-ml-2" (click)="stopTaskTimer(task)" *ngIf="task?.taskStartTime"
                        pTooltip="Stop Timer" tooltipPosition="bottom" style="color: red;font-size: 15px;"
                        [tooltipOptions]="{
                            showDelay: 50,
                            hideDelay: 50,
                            positionStyle: 'fixed',
                            appendTo: 'body'
                          }"
                          ></span>
                </span>

                <ng-container *ngIf="isMini && task?.childTaskDto?.length>0">
                    <div *ngFor="let childTask of task.childTaskDto">
                      <span *ngIf="((app?.userId == taskData?.createdBy || app?.userId == childTask?.taskUsers || app?.userId==childTask?.reAssignedTo))" class="p-mr-3 p-ml-2">
                        <span>{{getTimeTracked(childTask) | date :"HH:mm:ss":'UTC'}}</span>
                        <span class="cursor-pointer pi pi-clock p-ml-2"
                              (click)="startTaskTimer(childTask)"
                              *ngIf="!childTask?.taskStartTime && !childTask?.isCompleted"
                              pTooltip="Start Timer"
                              tooltipPosition="bottom"
                              [tooltipOptions]="{
                                showDelay: 50,
                                hideDelay: 50,
                                positionStyle: 'fixed',
                                appendTo: 'body'
                              }"
                              >
                        </span>
                        <span class="cursor-pointer fa fa-stop-circle-o p-ml-2"
                              (click)="stopTaskTimer(childTask)"
                              *ngIf="childTask?.taskStartTime"
                              pTooltip="Stop Timer"
                              tooltipPosition="bottom"
                              style="color: red;font-size: 15px;"
                              [tooltipOptions]="{
                                showDelay: 50,
                                hideDelay: 50,
                                positionStyle: 'fixed',
                                appendTo: 'body'
                              }"
                              >
                        </span>
                      </span>
                    </div>
                </ng-container>

                <span class="btnBars" (click)="onMaximize()" *ngIf="isMini">
                    <i class="pi pi-window-maximize"></i>
                </span>
                <span class="btnBars" (click)="cancelTask();">
                    <i class="pi pi-times"></i>
                </span>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="!isMini">
        <div class="header p-d-flex p-jc-between">
            <h5>
                <!-- Icons displayed based on task type -->
                <span class="pi pi-users" style="color:var(--primary-color)" *ngIf="task?.taskTypeId == TaskType.Group" 
                pTooltip="Multiple Task" tooltipPosition="left"
                [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"
                  ></span>
                <span class="pi pi-user" style="color:var(--primary-color)" *ngIf="task?.taskTypeId == TaskType.Individual" 
                pTooltip="Single Task" tooltipPosition="left"
                [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"
                  ></span>
                <span class="pi pi-id-card" style="color:var(--primary-color)" *ngIf="task?.taskTypeId == TaskType.Subtask" 
                pTooltip="Sub-Task" tooltipPosition="left"
                [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"
                  ></span>
                Task ID: {{ task.subTaskId ? task.subTaskId : task?.taskId }}
            </h5>
                <span *ngIf="showEditButton" class="btnBars p-mr-0" 
                pTooltip="Edit" tooltipPosition="top"
                [tooltipOptions]="{
                    showDelay: 50,
                    hideDelay: 50,
                    positionStyle: 'fixed',
                    appendTo: 'body'
                  }"
                  >
                    <i class="pi pi-pencil" style="position: initial; margin-left: -2px;"   (click)="editTask()"></i>
                </span>
        </div>
        <!-- Task Details Start -->
        <div class="card">
            <div class="p-grid p-mt-2">
                <div class="p-col-12 p-md-6">
                    <div class="p-grid task-details-wrapper">

                        <div class="p-col-4">
                            <p>
                                <i class="pi pi-calendar p-mr-1"></i><strong>Start Date & Time: </strong></p>
                        </div>
                        <div class="p-col-8">
                            <p>{{ task.startDateTime | localDate }}</p>
                        </div>

                        <div class="p-col-4">
                            <p><i class="pi pi-calendar p-mr-1"></i><strong>Due Date & Time: </strong></p>
                        </div>
                        <div class="p-col-8">
                            <p>{{ task.endDateTime | localDate }}</p>
                        </div>

                        <div class="p-col-4">
                            <p><strong>Task Category: </strong></p>
                        </div>
                        <div class="p-col-8">
                            <p>{{task?.taskCategory}}</p>
                        </div>

                        <div *ngIf="taskData?.relatedTo" class="p-col-4">
                            <p><strong>Related To: </strong></p>
                        </div>
                        <div *ngIf="taskData?.relatedTo" class="p-col-8">
                            <p>{{ taskData?.relatedTo }}</p>
                        </div>

                        <div *ngIf="taskData?.channelName" class="p-col-4">
                            <p><strong>Channel: </strong></p>
                        </div>
                        <div *ngIf="taskData?.channelName" class="p-col-8">
                            <p>{{ taskData?.channelName }}</p>
                        </div>

                        <div *ngIf="taskData?.relatedTo !== 'Account' && taskData?.taskStages?.length > 0" class="p-col-4">
                            <p><strong>{{(taskData?.relatedTo ? taskData?.relatedTo : '') + ' '}}Stages: </strong></p>
                        </div>
                        <div  *ngIf="taskData?.relatedTo !== 'Account' && taskData?.taskStages?.length > 0" class="p-col-8">
                            <p>{{taskStages}}</p>
                        </div>

                        <div *ngIf="taskData?.objectName" class="p-col-4">
                            <p><strong>Association Name:</strong></p>
                        </div>
                        <div *ngIf="taskData?.objectName" class="p-col-8">
                            <ng-container *ngFor="let association of taskData.associationNames; let i = index">
                                <span (click)="openViewPopUp(association?.id)" pTooltip="View Association Details" tooltipPosition="right"
                                    class="detail-task-popup-link">
                                    {{association?.businessName}}
                                </span>
                                  <!-- Add a comma if it's not the last item -->
                                <span *ngIf="i < taskData.associationNames.length - 1">, </span>
                            </ng-container>
                        </div>
                        <div *ngIf="taskData.task?.priority" class="p-col-4">
                            <p><strong>Priority:</strong></p>
                        </div>
                        <div *ngIf="taskData.task?.priority" class="p-col-8">
                            <p-tag [value]=" taskData.task?.priority" [style]="{'background-color': taskData.task?.priorityColor}" severity="info">
                            </p-tag>
                        </div>

                    </div>
                </div>

                <div class="p-col-12 p-md-6">
                    <div class="p-grid task-details-wrapper">

                        <ng-container *ngIf="[TaskType.Individual,TaskType.Subtask].includes(task?.taskTypeId) && taskData?.reAssignedTo">
                            <div class="p-col-4">
                                <p><i class="pi pi-user p-mr-1"></i><strong>Re-Assign To: </strong></p>
                            </div>
                            <div class="p-col-8">
                                <p>
                                    {{ taskData?.reAssignedToName ?? "No user assigned." }}
                                </p>
                            </div>

                            <div class="p-col-4">
                                <p><i class="pi pi-calendar p-mr-1"></i><strong>Re-Assign Date: </strong></p>
                            </div>
                            <div class="p-col-8">
                                <p>
                                    {{ taskData?.reAssignedDate  | localDate }}
                                </p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="[TaskType.Individual,TaskType.Subtask].includes(task?.taskTypeId)">
                            <div class="p-col-4">
                                <p><i class="pi pi-user p-mr-1"></i><strong>Assign To: </strong></p>
                            </div>
                            <div class="p-col-8">
                                <p>{{ taskData?.assignedToName ?? "No users assigned." }}</p>
                            </div>
                        </ng-container>

                        <div *ngIf="task?.sharedTaskUsers?.length > 0" class="p-col-4">
                            <p><i class="pi pi-user p-mr-1"></i><strong>Share task with({{task?.sharedTaskUsers?.length||0}}):</strong></p>
                        </div>
                        <div *ngIf="task?.sharedTaskUsers?.length > 0" class="p-col-8">
                            <p>{{taskSharedWith}}</p>
                        </div>

                        <div class="p-col-4">
                            <p><i class="pi pi-user p-mr-1"></i><strong>Created By: </strong></p>
                        </div>
                        <div class="p-col-8">
                            <p>{{ task?.createdByName }}</p>
                        </div>
                        <div class="p-col-4"  *ngIf="showCheckbox()">
                            <p><strong>Restrict Notifications & Email:</strong></p>
                        </div>
                        <div class="p-col-8" *ngIf="showCheckbox()">
                            <p-checkbox 
                                    [(ngModel)]="notificatonEmailCheckbox" 
                                    [binary]="true"
                                    (onChange)="onNotificationCheckboxChange($event)"
                                    [disabled]="isCheckboxDisabled()"
                                    inputId="binary" />
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div *ngIf="task?.childTaskOrder" class="p-grid">
                <div class="p-col-2">
                    <p><strong>Task Order:</strong></p>
                </div>
                <div class="p-col-10">
                    <p-checkbox  [(ngModel)]="task.childTaskOrder" [disabled]="true" binary="true"></p-checkbox>
                </div>
            </div>

            <div *ngIf="task?.name" class="p-grid">
                <div class="p-col-2">
                    <p><strong>Task Title:</strong></p>
                </div>
                <div class="p-col-10">
                    <p>{{ task?.name }}</p>
                </div>
            </div>

            <div class="p-grid" *ngIf="[TaskType.Individual,TaskType.Subtask].includes(task?.taskTypeId)">
                <div class="p-col-2">
                    <p><strong>Task Details:</strong></p>
                </div>
                <div class="p-col-10">
                    <span class="task-details" [innerHTML]="getSanitizedDescription(task?.description)"></span>
                </div>
            </div>

            <div class="p-grid" *ngIf="checkList?.length>0">
                <div class="p-col-2">
                    <p><strong>Checklist: </strong></p>
                </div>
                <div class="p-col-10">
                    <ul class="list-detials">
                        <ng-container *ngFor="let list of checkList; let i = index;">
                            <li>
                                <div class="p-d-flex p-ai-center">
                                    <p-checkbox class="p-mt-1" [(ngModel)]="list.isCheck" binary="true"
                                        (onChange)="onCheckboxChange(list)" [disabled]="!(app?.userId==taskData?.createdBy || app?.userId==taskData?.assignedTo || app?.userId==taskData?.reAssignedTo)"></p-checkbox><span class="p-ml-1">{{list.description}}</span>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <div class="p-grid" *ngIf="task?.taskAttachments?.length>0">
                <div class="p-col-2">
                    <p><strong>Attachments: </strong></p>
                </div>
                <div class="p-col-10">
                    <ul class="list-detials">
                        <ng-container *ngFor="let attachmentData of task?.taskAttachments; let i = index;">
                            <li>
                                <div class="p-d-flex p-ai-center">
                                    <a [download]="attachmentData.attachment.name" [href]="attachmentData.attachment.location" target="_blank">
                                        {{ attachmentData.attachment.name }}
                                    </a>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>


        </div>
        <!-- Task Details End -->

        <ng-container *ngIf="[TaskType.Individual,TaskType.Subtask].includes(task.taskTypeId)">
            <ng-container *ngTemplateOutlet="taskDetailsWithHistory; context: { $implicit: task, showDetails: false }"></ng-container>
        </ng-container>

        <ng-container *ngIf="task?.childTaskDto?.length>0">
            <ng-container *ngFor="let subTaskDetails of task?.childTaskDto; let i = index">
                <ng-container *ngTemplateOutlet="taskDetailsWithHistory; context: { $implicit: subTaskDetails, showDetails: true,index:i }"></ng-container>
            </ng-container>
        </ng-container>

    </ng-container>
    <p-footer class="p-d-flex p-jc-between">
        <div class="p-toolbar-group-left">
        <button *ngIf="showEditButton" type="button" pButton label="Delete" (click)="deleteTask()" class="p-button-danger"></button>
        </div>
        <div class="p-toolbar-group-right">
        <button pButton (click)="cancelTask()" label="Close" class="p-button-secondary"></button>
        </div>
    </p-footer>
</p-dialog>
    
<ng-template #taskDetailsWithHistory let-taskViewDetails let-showDetails="showDetails" let-parentTask="parentTask" let-i="index">
    <div class="p-d-flex">
        <div *ngIf="taskViewDetails?.subTaskId && showDetails" class="child-border">
            <div class="line"></div>
            <div class="line2" *ngIf="i < task?.childTaskDto?.length - 1 && task?.taskTypeId == TaskType.Individual"></div>
            <div class="line2" *ngIf="i < parentTask?.childSubTasks?.length - 1"></div>
        </div>
        <p-panel [ngClass]="{'child-task-margin-top': task?.taskTypeId == 2 && !taskViewDetails?.subTaskId}" [toggleable]="true" [class.child-panel] = "taskViewDetails?.subTaskId && showDetails" class="w-100 border-shadow">
            <ng-template pTemplate="header">
                <div class="p-grid w-100">
                    <div class="p-d-flex p-col-12 p-ai-center" *ngIf="taskViewDetails?.subTaskId && showDetails">
                        <div><strong>SubTask ID:</strong> {{taskViewDetails?.subTaskId}}</div>
                        <span *ngIf="showSubTaskEditButton" class="btnBars p-mr-0">
                            <i class="pi pi-pencil"   pTooltip="Edit Sub Task"
                            tooltipPosition="left"  (click)="editSubTask(taskViewDetails)"></i>
                        </span>
                        <!-- delete -->
                        <span *ngIf="showSubTaskEditButton" class="btnBars p-mr-0">
                            <i class="pi pi-trash" pTooltip="Delete Sub Task"
                            tooltipPosition="left"  (click)="deleteSubTask(taskViewDetails)"></i>
                        </span>
                    </div>
                    <div class="p-d-flex p-col-3">
                        <div><p><i class="pi pi-user p-mr-2"></i><strong>{{taskViewDetails?.reAssignedStatus ? taskViewDetails?.reAssignedToName : taskViewDetails?.taskUsersName }}</strong>
                            <span *ngIf="task?.isSharedUser && !taskViewDetails.isCompleted" class="btnBars p-mr-0">
                                <i class="pi pi-bell" pTooltip="Send reminder to task assignee"
                                tooltipPosition="top"  (click)="sendReminderToAssignees(taskViewDetails)"></i>
                            </span>
                        </div>
                    </div>
                    <div class="p-d-flex p-col-5">
                        <div>Time Spent:</div>
                        <div style="border-bottom: 1px solid var(--primary-color); min-width: 3rem;"
                            (click)="fetchTimerHistory($event,taskViewDetails)" class="cursor-pointer">
                            {{taskViewDetails.totalTaskTimeSpent}}
                        </div>
                        <div class="p-mx-2">Clocking:</div>
                        <div>{{getTimeTracked(taskViewDetails) | date :"HH:mm:ss":'UTC'}}</div>
    
                        <ng-container *ngIf="((app?.userId==taskData?.createdBy || app?.userId==taskViewDetails?.taskUsers || app?.userId==taskViewDetails?.reAssignedTo) && taskViewDetails?.isValid)">
                            <span class="cursor-pointer pi pi-clock p-ml-2" (click)="startTaskTimer(taskViewDetails)"
                            *ngIf="!taskViewDetails?.taskStartTime && !taskViewDetails?.isCompleted" pTooltip="Start Timer" tooltipPosition="top"></span>
                            <span class="cursor-pointer fa fa-stop-circle-o p-ml-2"
                                (click)="stopTaskTimer(taskViewDetails)" *ngIf="taskViewDetails?.taskStartTime" pTooltip="Stop Timer"
                                tooltipPosition="top" style="color: red;font-size: 15px;"></span>
                        </ng-container>
                    </div>
                    <div class="p-d-flex p-col-4" style="flex-direction: initial">
                        <div class="task-time">
                            <strong>Start Date:</strong></div>
                        <div class="p-mr-2 task-time"><strong>{{taskViewDetails.startDateTime |
                                localDate}}</strong></div>
                        <div class="task-time"><strong>Due Date:</strong></div>
                        <div class="task-time"><strong>{{taskViewDetails.endDateTime | localDate}}</strong>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-container *ngIf="showDetails">
                <div class="activity-card">
                    <div class="p-grid">
                        <div class="p-col-12" [ngClass]="{'p-md-6': taskViewDetails?.reAssignedStatus}">

                            <div class="p-grid" *ngIf="taskViewDetails?.subTaskId">
                                <div class="p-col-2">
                                    <p><strong>Priority:</strong></p>
                                </div>
                                <div class="p-col-10">
                                    <p-tag [value]=" taskViewDetails.priority" [style]="{'background-color': taskViewDetails.priorityColor}" severity="info">
                                    </p-tag>
                                </div>
                            </div>

                            <div class="p-grid">
                                <div class="p-col-2">
                                    <p><strong>Task Details:</strong></p>
                                </div>
                                <div class="p-col-10">
                                    <span class="task-details" [innerHTML]="getSanitizedDescription(taskViewDetails?.description)"></span>
                                </div>
                            </div>

                            <div class="p-grid" *ngIf="taskViewDetails?.taskCheckLists?.length>0">
                                <div class="p-col-2">
                                    <p><strong>Checklist: </strong></p>
                                </div>
                                <div class="p-col-10 task-details">
                                    <ul class="list-detials">
                                        <ng-container *ngFor="let list of taskViewDetails?.taskCheckLists; let i = index;">
                                            <li>
                                                <div class="p-d-flex p-ai-center">
                                                    <p-checkbox class="p-mt-1" [(ngModel)]="list.isCheck" binary="true"
                                                        (onChange)="onCheckboxChange(list)" [disabled]="!((app?.userId==taskData?.createdBy || app?.userId==taskViewDetails?.taskUsers || app?.userId==taskViewDetails?.reAssignedTo) && taskViewDetails?.isValid)"></p-checkbox><span class="p-ml-1">{{list.description}}</span>
                                                </div>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="taskViewDetails?.reAssignedStatus" class="p-col-12" [ngClass]="{'p-md-6': taskViewDetails?.reAssignedStatus}">
                            <div class="p-grid task-details-wrapper">
                                <div class="p-col-4">
                                    <p><i class="pi pi-user p-mr-1"></i><strong>Re-Assign To: </strong></p>
                                </div>
                                <div class="p-col-8">
                                    <p>{{ taskViewDetails?.reAssignedToName }}</p>
                                </div>

                                <div class="p-col-4">
                                    <p><i class="pi pi-calendar p-mr-1"></i><strong>Re-Assign Date: </strong></p>
                                </div>
                                <div class="p-col-8">
                                    <p>{{ taskViewDetails?.reAssignedDate | localDate }}</p>
                                </div>

                                <div class="p-col-4">
                                    <p><i class="pi pi-user p-mr-1"></i><strong>Assign To: </strong></p>
                                </div>
                                <div class="p-col-8">
                                    <p>{{ taskViewDetails?.taskUsersName }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="comment-header p-d-flex p-jc-between p-ai-center p-mb-3">
                <h6 class="p-mb-0"><i class="pi pi-clipboard p-mr-1"></i>History</h6>
                <p-dropdown
                [options]="taskActionOptions | filterTaskOptions:taskViewDetails:app?.userId:taskData.task?.sharedTaskUsers" class="action-btn" [(ngModel)]="selectedTaskOption"
                optionLabel="name" (onChange)="changeTaskOption(taskViewDetails)" appendTo="body"
                placeholder="Actions" [disabled]="!(([taskData?.createdBy,taskData?.assignedTo,taskData?.reAssignedTo,taskViewDetails?.taskUsers,taskViewDetails?.reAssignedTo,taskViewDetails?.createdBy].includes(app?.userId) || taskData.task?.isSharedUser) && taskViewDetails?.isValid)" />
            </div>
            <div class="p-p-0" style="margin-top:0.4rem">
                <div class="timeline" *ngFor="let stageDetails of taskViewDetails.commentTimelines; let j = index">
                    <div class="timeline-separator">
                        <div class="timeline-marker"></div>
                        <div class="timeline-connector"></div>
                    </div>
                    <div class="timeline-right p-pr-0 w-100">
                        <h6 class="timeline-stage-info">
                            <button type="button" pButton pRipple
                                class="p-button-text p-button-rounded p-button-plain group-expand-button"
                                (click)="toogleTimelineActivity(stageDetails)"
                                [icon]="stageDetails?.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                            </button>
                            <div class="p-d-flex status-container w-100 p-ai-center">
                                <div>
                                    <p-tag 
                                        [value]="stageDetails.status.name" 
                                        [style]="{'background-color': stageDetails.status.statusColor}" 
                                        severity="info">
                                    </p-tag>
                                </div>
                                <div class="stage-username p-ml-2">
                                   - {{stageDetails.groupUserName}}
                                </div>
                            </div>
                        </h6>
                        <ng-container *ngIf="stageDetails?.expanded">
                            <p-card *ngFor="let statusData of stageDetails.commentList | slice:0:stageDetails.visibleCount;  let i = index;" class="activity-card">
                                <div class="p-d-flex">
                                    <div class="activity-icon {{statusData?.colorClass}} p-shadow-3">
                                        <span [class]="statusData?.icon"></span>
                                    </div>
                                    <div class="activity-content">
                                        <h6 class="p-mb-1" style="display: inline-block;">
                                            {{ statusData.statusHeader }}
                                        </h6>
                                        <span class="p-ml-4">
                                            <span>{{statusData.createdDate | localDate}}</span>
                                        </span>
    
                                        <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                                            <span class="task-details" [innerHTML]="getSanitizedDescription(statusData?.description)"></span>
                                        </p>
    
                                        <ng-container *ngIf="statusData.taskStatusAttachments?.length>0">
                                            <div class="p-mt-2">
                                                <strong>Attachments:</strong>
                                            </div>
                                            <ul class="list-detials">
                                                <ng-container *ngFor="let attachmentData of statusData.taskStatusAttachments; let i = index;">
                                                    <li>
                                                        <div class="p-d-flex p-ai-center">
                                                            <a [download]="attachmentData.attachment.name" [href]="attachmentData.attachment.location" target="_blank">
                                                                {{ attachmentData.attachment.name }}
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </ng-container>
                                    </div>
                                </div>
                            </p-card>
                            <div class="p-d-flex p-jc-center p-mt-2" *ngIf="stageDetails.commentList?.length > stageDetails.visibleCount">
                                <button pButton type="button" label="Load More" 
                                 class="p-button-text"
                                 style="font-size: 1.3rem; padding: 0.75rem 1.5rem;"                   
                                (click)="loadMoreComments(stageDetails)">
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </p-panel>
    </div>
    <ng-container *ngIf="taskViewDetails?.childSubTasks?.length > 0">
        <ng-container *ngFor="let subTaskDetails of taskViewDetails?.childSubTasks; let i = index">
            <ng-container *ngTemplateOutlet="taskDetailsWithHistory; context: { $implicit: subTaskDetails, showDetails: true,index:i ,parentTask: taskViewDetails }"></ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<p-overlayPanel #timers styleClass="no-padding">
    <p-table [value]="timeSpent" responsiveLayout="scroll" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="body" let-time>
            <tr>
                <td>{{time?.startByUserName}}</td>
                <td>{{app._showDateTimeWithZone(time?.taskTimerDate)| localDate}}</td>
                <td>{{time?.totalTaskTimeSpent}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2">No history found.</td>
            </tr>
        </ng-template>
    </p-table>
</p-overlayPanel>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>

<!-- Task Add Comment Form on View Task Details From -->
<p-dialog header="Comment" [modal]="true" [maximizable]="false" [responsive]="true" [(visible)]="displayComment"
    [style]="{width: '50vw'}" [focusOnShow]="false">
    <ng-container>
        <form [formGroup]="addCommentForm">
            <div class="header p-d-flex">
                <input type="text" style="min-width: 150px;" class="small" [readonly]="true" pInputText
                    formControlName="assignTo">
                <span class="btnBars p-mt-1"
                    tooltipPosition="top">
                    <i class="pi pi-user"></i>
                </span>
            </div>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-12 p-md-6">
                        <label for="status">Status <span style="color: red">*</span></label>
                        <p-dropdown [options]="allTaskStatus" optionLabel="name" optionValue="id"
                            formControlName="status"
                            appendTo="body" placeholder="Select Status"></p-dropdown>
                    </div>

                    <div class="p-col-12 p-md-6">
                        <label for="attachments">Share Files (Max Size 2MB) <i class="pi pi-exclamation-circle" [escape]="false"
                                [pTooltip]="multiLineTooltip" tooltipPosition="top"></i></label>
                        <p-fileUpload (onSelect)="onCustomUpload($event.files)" [showUploadButton]="false"
                            customUpload="true" [showCancelButton]="false" [multiple]="true">
                            <ng-template pTemplate="file"></ng-template>
                            <ng-template pTemplate="content">
                                <ng-container *ngFor="let file of taskStatusAttachments; let i = index;">
                                    <div class="p-fileupload-row p-mb-2">
                                        <button pButton icon="fa fa-download" (click)="downloadFile(
                                            file?.attachment
                                                .name,
                                                file?.attachment
                                                .content
                                        )" class="p-button-link p-px-0 p-py-0">
                                        </button>
                                        <div>
                                            {{ file.attachment.name }}
                                        </div>
                                        <div>
                                            {{ file.attachment.sizeInBytes | fileSize }}
                                        </div>
                                        <div>
                                            <button icon="pi pi-times" pButton (click)="removeAttachment(i)"
                                                type="button" icon="pi pi-times">
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-12">
                        <label for="comments">Comments</label>
                        <p-editor styleClass="task-editor" formControlName="comments"
                            [style]="{'height':'100px'}">
                            <p-header>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="small">small</option>
                                        <option selected></option>
                                        <option value="large">large</option>
                                        <option value="huge">huge</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <select class="ql-size">
                                        <option value="24px">24</option>
                                        <option value="48px">48</option>
                                        <option value="100px">100</option>
                                        <option value="200px">200</option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-bold" aria-label="Bold"></button>
                                    <button class="ql-italic" aria-label="Italic"></button>
                                    <button class="ql-underline" aria-label="Underline"></button>
                                    <button class="ql-strike" aria-label="Strike"></button>
                                </span>
                                <span class="ql-formats">
                                    <select title="Text Color" class="ql-color"></select>
                                    <span class="ql-format-separator"></span>
                                    <select title="Background Color" class="ql-background"></select>
                                </span>
                                <span class="ql-formats">
                                    <button class="ql-list" value="ordered"></button>
                                    <button class="ql-list" value="bullet"></button>
                                    <select title="Text Alignment" class="ql-align">
                                        <option selected>Gauche</option>
                                        <option value="center" label="Center"></option>
                                        <option value="right" label="Right"></option>
                                        <option value="justify" label="Justify"></option>
                                    </select>
                                </span>
                                <span class="ql-formats">
                                    <button aria-label="Link" class="ql-link"></button>
                                </span>
                            </p-header>
                        </p-editor>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelComment()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveComment()" label="Submit"></button>
    </ng-template>
</p-dialog>

<!-- re-assign -->
<p-dialog header="Re-assign" [modal]="true" [(visible)]="displayReassign" [style]="{ width: '60rem' }">
    <form [formGroup]="reAssignUserForm">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-6 p-d-flex">
                <ng-container>
                <div class="p-mr-2">To: </div>
                <span (click)="reassignUser()" *ngIf="!reAssignUserForm.get('reAssignedTo').value" class="hyper-link">
                    <strong class="association-name">
                        <i class="pi pi-plus p-mr-2"></i>
                        Select Users
                    </strong>
                </span>
                <span (click)="reassignUser()" *ngIf="reAssignUserForm.get('reAssignedTo').value" class="hyper-link">
                    <strong class="association-name">
                        <i class="pi pi-user-edit p-mr-2" pTooltip="Edit"
                        tooltipPosition="top"></i>
                        {{ reAssignUserForm.get('reAssignedTo').value.name }}
                    </strong>
                </span>
                <div *ngIf="detailsFormErrors?.reAssignedTo" class="p-invalid p-ml-1">
                    <small>{{ detailsFormErrors?.reAssignedTo }}</small>
                </div>
            </ng-container>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label for="description">Description</label>
                <p-editor styleClass="task-editor" [style]="{'height':'100px'}" formControlName="description">
                    <p-header>
                        <span class="ql-formats">
                            <select class="ql-size">
                                <option value="small">small</option>
                                <option selected></option>
                                <option value="large">large</option>
                                <option value="huge">huge</option>
                            </select>
                        </span>
                        <span class="ql-formats">
                            <select class="ql-size">
                                <option value="24px">24</option>
                                <option value="48px">48</option>
                                <option value="100px">100</option>
                                <option value="200px">200</option>
                            </select>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-bold" aria-label="Bold"></button>
                            <button class="ql-italic" aria-label="Italic"></button>
                            <button class="ql-underline" aria-label="Underline"></button>
                            <button class="ql-strike" aria-label="Strike"></button>
                        </span>
                        <span class="ql-formats">
                            <select title="Text Color" class="ql-color"></select>
                            <span class="ql-format-separator"></span>
                            <select title="Background Color" class="ql-background"></select>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-list" value="ordered"></button>
                            <button class="ql-list" value="bullet"></button>
                            <select title="Text Alignment" class="ql-align">
                                <option selected>Gauche</option>
                                <option value="center" label="Center"></option>
                                <option value="right" label="Right"></option>
                                <option value="justify" label="Justify"></option>
                            </select>
                        </span>
                        <span class="ql-formats">
                            <button aria-label="Link" class="ql-link"></button>
                        </span>
                    </p-header>
                </p-editor>
            </div>
        </div>
    </div>
</form>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelReAssignPopup()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveReAssignUserData()" label="Submit"></button>
    </ng-template>
</p-dialog>

    @if(displayAddEditDialog){
        <app-shared-create-task [headerTitle]="'Edit Task'"
                [displayAddEditDialog]="displayAddEditDialog"
                [taskEditId]="selectedTaskId" (loadNewList)="loadNewList()"
                (cancelClicked)="closeTaskEdit()">
        </app-shared-create-task>
    }
    @if(displayAccountViewEdit){  <!-- Account Edit Component -->
        <app-edit-account
                [displayEditViewDialog]="displayAccountViewEdit" [displayView]="true"
                [selectedAccountId]="selectedAccountId"
                (getAccountListAfterEdit)="reloadResultAfterSave()"
                (closeModal)="closeAccountViewEditModal()">
        </app-edit-account>
    }
    @if(displayLeadViewEdit){ <!-- Lead View/Edit -->
        <app-add-update-view-lead
                [display]="true" [selectedLeadId]="selectedLeadId"
                [selectedChannelId]="taskData?.channelId"
                [crudType]="'view'" (cancelClicked)="closeLeadViewEdit()"
                (onComplete)="reloadResultAfterSave()">
        </app-add-update-view-lead>

    } 
    @if(displayOpportunityViewEdit){ <!-- Opportunity View/Edit -->
        <app-opportunity-add-edit-dialog
                [displayAddEditDialog]="displayOpportunityViewEdit"
                [opportunityChannelId]="taskData?.channelId" [opportunityId]="opportunityEditViewId"
                [crudType]="'view'"(reloadList)="reloadResultAfterSave($event)"
                (closeModal)="closeOpportunityViewEdit()">
        </app-opportunity-add-edit-dialog>

    }
    @if(displayCaseViewEdit){ <!-- Cases Edit/View -->
        <app-cases-add-edit-dialog
                [displayAddEditDialog]="displayCaseViewEdit" [casesId]="caseEditViewId"
                [crudType]="'view'" [casesChannelId]="taskData?.channelId"
                [callFromAccountTab]="false" [casesChannelList]="null"
                [groupUserList]="groupUserList" (reloadList)="reloadResultAfterSave($event)"
                (closeModal)="closeCaseViewEdit()">
        </app-cases-add-edit-dialog>
    }

<!-- Assign-To-User pop-up -->
<app-assign-users [displayUsersPopup]="displayUsers"
    [selectedUsersList]="selectedReassignUser"
    [singleSelection] ="true"
    (saveAssignDataclicked)="saveReAssignUser($event)"
    (cancelClicked)="assignUserPopupCancelClicked()">
</app-assign-users>

<!-- Create Sub-Task -->
<ng-container *ngIf="displaySubTask">
    <app-add-edit-sub-task  [displaySubTaskPopup]="displaySubTask" [editedSubtaskDetails]="editedSubtaskDetails" [taskData]="selectedTaskDataForSubTask" (cancelClicked)="closeSubTaskPopup()" [selectedTaskTypeId]="this.task?.taskTypeId"
    (loadNewList)="loadNewList()" ></app-add-edit-sub-task>
</ng-container>

<p-confirmDialog [style]="{width: '20vw'}" key="confirm-task" [baseZIndex]="1000000"></p-confirmDialog>
